// select2 の dist ビルドは CommonJS 環境では「呼び出して初期化する
// ファクトリ関数」を module.exports に入れるだけで、自動では
// jQuery.fn.select2 を定義しない(UMD の AMD/CJS 検出による)。
// そのため明示的にファクトリを呼ぶ。引数なしで呼ぶと内部で
// require("jquery")(=バンドル内の同一 jQuery インスタンス)が使われる。
// dropdownCssClass は Select2 4.x の compat モジュール側の実装で、
// select2.full にしか含まれない。plain な select2 に戻すと
// ヘッダー検索のドロップダウン幅指定が効かなくなる。
import select2Factory from "select2/dist/js/select2.full";

select2Factory();
